import {CsvDataRow} from '@/incoming-balance/types/CsvDataRow.type'
import {ColumnMapping} from '@/incoming-balance/types/ColumnMapping.type'

export const getValue = (columnKey: string, csvRow: CsvDataRow, colMapping: ColumnMapping): string | number => {
    const colIndex = colMapping[columnKey]
    return csvRow[colIndex]
}

export const updateRowValue = (columnKey: string, value: string | number, csvRow: CsvDataRow, colMapping: ColumnMapping): CsvDataRow => {
    if (colMapping[columnKey] === undefined) {
        return csvRow
    }
    const colIndex = colMapping[columnKey]
    const updatedRow = [...csvRow]
    updatedRow[colIndex] = value
    return updatedRow
}